import { gql } from 'graphql-tag';
import { useQuery } from '@apollo/client';

export const PROJECTS_BILLING_SETTINGS = gql`
  query projectsBillingSettings(
    $page: Int!
    $pageSize: Int!
    $projectFilter: ProjectFilter2
  ) {
    projects(page: $page, pagesize: $pageSize, projectFilter: $projectFilter) {
      id
      projectBillSettings {
        billLineItemsBy
        description
        internalNotes
        showComments
        defaultInvoicePaymentTerm
        invoiceCurrency {
          id
          symbol
        }
        taxProfile {
          id
          displayText
        }
        invoiceTemplate {
          id
          displayText
        }
        poNumber
      }
    }
  }
`;

export const useProjectDefaultBillingData = ({ projectIds, skip }) => {
  const { data } = useQuery(PROJECTS_BILLING_SETTINGS, {
    variables: {
      page: 1,
      pageSize: projectIds.length,
      projectFilter: { projects: projectIds }
    },
    skip: skip || !projectIds.length,
    errorPolicy: 'all',
    fetchPolicy: 'network-only'
  });

  return (data?.projects || []).reduce(
    (acc, { id, projectBillSettings }) => ({
      ...acc,
      [id]: projectBillSettings
    }),
    {}
  );
};

export default useProjectDefaultBillingData;
